import { render, staticRenderFns } from "./PreSaveActionModal.vue?vue&type=template&id=b1d77184&scoped=true"
import script from "./PreSaveActionModal.vue?vue&type=script&lang=ts"
export * from "./PreSaveActionModal.vue?vue&type=script&lang=ts"
import style0 from "./PreSaveActionModal.vue?vue&type=style&index=0&id=b1d77184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d77184",
  null
  
)

export default component.exports